import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { withRouter } from 'react-router-dom'
import { isLoggedIn } from './selectors'

const withLoggedInInfo = connect(state => ({
  isLoggedIn: isLoggedIn(state)
}))

const redirectIfLoggedIn = destination =>
  lifecycle({
    componentWillMount() {
      const { isLoggedIn, history } = this.props
      if (!!isLoggedIn && destination) {
        history.replace(destination)
      }
    }
  })

export default compose(
  withRouter,
  withLoggedInInfo,
  redirectIfLoggedIn('/explore')
)



// WEBPACK FOOTER //
// ./src/services/session/redirectToHomeIfLoggedIn.js